import { BaseService } from '@core/service/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export class LicenseGrantService extends BaseService{

  url = "api/license";

  httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'multipart/form-data'})
};

  constructor(http: HttpClient) {
    super(http);
  }

  /** GET, Will 404 if id not found */
  get(): Observable<any> {
    const url = `${this.getUrl()}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`update licenseGrant file`)),
      catchError(this.handleError<any>(`geted licenseInfo fail`))
    );
  }

  changeLicense(file:File):Observable<any>{
    let fd : FormData = new FormData();
    fd.append("file",file,file.name);
    return this.http.post<any>(this.getUrl(), fd).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

  getUrl(): string {
    return this.url;
  }
}
